export enum OrganizationFunctionalTypeEnum
{
    Universal = 'Universal',
    Seller = 'Seller',
    Buyer = 'Buyer'
}
